import React from 'react'
import { useNavigate } from 'react-router-dom'

const Resume = () => {

  const navigation = useNavigate();

  /*return (
    <div style={{marginBottom: '50px'}}>
      <div style={{width: '100%', display: 'flex'}}>
        <h1 className='title'>Resume</h1>
        <button className='resumeDownload page-button secondary ' onClick={() =>window.location.href='https://thomasdawson.biz/downloads/ThomasDawsonResume.docx'}>Download</button>
      </div>
      <div style={{width: '85%', margin: 'auto'}}>
        <div className='container'>
          <h1 className='td'>Thomas Dawson</h1>
          <div className='top-bar'>
            <h2 className='bar-item'>thdawson1999@gmail.com</h2>
            <h2 className='bar-item'>(701) 630-0703</h2>
            <h2 className='bar-item'>Fargo, ND</h2>
          </div>
          <p className='mission'>A fast learning, motived self-starter, looking for entry level opportunities to build
             responsive and scalable systems that will solve the end-user’s problems. Seeking to leverage development and problem-solving skills to contribute to the team at any company with the right fit.</p>
          <div className='section'>
            <h1 className='subheading'>Work Experience</h1>
            <hr />
            <h1>Omnibyte Technology - <span className='light'>Software Engineering Intern</span></h1>
            <p className='work-range'>August 2021 - December 2022</p>
            <ul className='sub'>
              <li>Created features for full stack, customer-facing web app (Angular, Ionic, .NET Framework, SQL Server)</li>
              <li>Built unit testing for .NET API and Angular/Ionic components</li>
              <li>Implemented several in house projects: specialized testing endpoint, proof of concept projects</li>
              <li>Fixed bugs for the full stack, mainly focused on the Angular app and .NET API</li>
            </ul>
            <div style={{display: 'flex'}}>
              <h1 className='subheading'>Projects</h1>
              <button style={{marginTop: '0px', marginLeft: 'auto'}} className='page-button primary' onClick={() => navigation('/projects')}>Projects</button>
            </div>
            <hr />
            <h1>Realtime Initiative Tracker</h1>
            <ul className='sub'>
              <li>App that allows multiple users to connect to a session to view turn order in role playing games</li>
              <li>Refreshes in real-time using web sockets for near instant updates</li>
              <li>Built with Angular front end, and an Express JS server backend for connecting web sockets</li>
            </ul>
            <h1>Trial of Fire</h1>
            <ul className='sub'>
              <li>A first-person game created using the Unity Engine and C# scripting</li>
              <li>Lead a small development team to finish project for a full free release</li>
              <li>Grew project management and collaboration skills</li>
            </ul>
            <h1>NDSU Capstone Project</h1>
            <ul className='sub'>
              <li>Worked with Scheels to create an app to help keep track of late/absent employees</li>
              <li>Divided up tasks within the group using Jira issue and bug tracking</li>
              <li>Built fast and responsive frontend using ReactJS, and backend using .NET Core and PostgreSQL</li>
              <li>Met with Scheels weekly to discuss and technical and design challenges</li>
            </ul>
            <h1 className='subheading'>Education</h1>
            <hr />
            <h1>North Dakota State University  - <span className='light'>Fargo, ND</span></h1>
            <ul className='sub'>
              <li>79 Credits towards BS in Computer Science</li>
              <li>Relevant Courses: Capstone project, Advanced Software Dev, Algorithms and Data Structures, Ethical Hacking, Database Systems, Comparative Programming Languages, Networking/Parallel Computation</li>
            </ul>
            <h1 className='subheading'>Skills</h1>
            <hr />
            <ul className='sub'>
              <li>HTML/CSS, JavaScript, Angular (Typescript), React, C#, .Net Core, SQL, Python, Java, Git, DevOps, REST APIs, Unity Engine</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  ) */

     return (
    <section className="resume-section">
      <h1 className='title'>Resume</h1>

      <div className="resume-frame">
        <iframe
          src="./Imgs/resume.pdf"
          title="Resume PDF"
          width="100%"
          height="900px"
        />
      </div>
    </section>
  );
}

export default Resume